import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBEMClasses } from "@circle-react/hooks/utils/useBEMClasses";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface AvatarProps {
  [key: string]: unknown;
  isFullRounded?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
}

export const Avatar = (props: AvatarProps) => {
  const blockElement = "skeleton-loader__avatar";
  const { modifiers } = useBEMClasses(blockElement, props);
  const { isFullRounded = true } = props;

  return (
    <div className={classNames(blockElement, modifiers)}>
      <div
        className={classNames(
          legacyClassNames("skeleton-loader__avatar-content"),
          "!bg-tertiary",
          isFullRounded ? "!rounded-full" : "!rounded-md",
        )}
      />
    </div>
  );
};
